// Port of api/fuel/app/classes/controller/api/monty/tags/add.php
import DB from 'offline/db'
import {
	attachField,
	familyTagIds,
	loadOwnedTag,
	persist,
	sessionUserId,
	touchAttachmentCounts,
	unauthorised,
	uniqueIndex
} from './shared'

export default function(params) {
	var userId = sessionUserId(params)
	var tag = false
	var field = false
	var index = uniqueIndex(params.index || [])
	var remainingIndex = []
	var familyIds = []
	var tagIds = []
	var existingRows = []
	var existingMap = {}
	var i = 0

	if (!userId) {
		return unauthorised()
	}

	tag = loadOwnedTag(userId, params.tag)
	if (!tag) {
		return unauthorised()
	}

	field = attachField(parseInt(tag.tag_context, 10) || 0)
	if (!field) {
		return unauthorised()
	}

	if (!index.length) {
		return persist({ index: [] })
	}

	existingRows = DB.query('SELECT ' + field + ' AS id FROM tag_attach WHERE tag_id = ? AND ' + field + ' IN (' + index.map(function() { return '?' }).join(', ') + ')', [
		parseInt(tag.tag_id, 10) || 0
	].concat(index))

	for (i = 0; i < existingRows.length; i++) {
		existingMap[parseInt(existingRows[i].id, 10) || 0] = true
	}

	for (i = 0; i < index.length; i++) {
		if (!existingMap[index[i]]) {
			remainingIndex.push(index[i])
			DB.run('INSERT INTO tag_attach (tag_id, family_id, user_id, group_id, buddies_id, game_id, collection_id, rating_id, play_id, tag_attach_date) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?)', [
				parseInt(tag.tag_id, 10) || 0,
				parseInt(tag.family_id, 10) || 0,
				parseInt(userId, 10) || 0,
				0,
				0,
				field === 'game_id' ? index[i] : 0,
				field === 'collection_id' ? index[i] : 0,
				field === 'rating_id' ? index[i] : 0,
				field === 'play_id' ? index[i] : 0,
				Math.floor(Date.now() / 1000)
			])
		}
	}

	tagIds.push(parseInt(tag.tag_id, 10) || 0)
	if (parseInt(tag.family_id, 10) || 0) {
		familyIds.push(parseInt(tag.family_id, 10) || 0)

		var familyRows = DB.query('SELECT * FROM tag_family WHERE family_id = ? LIMIT 1', [tag.family_id])
		if (remainingIndex.length && familyRows.length && (parseInt(familyRows[0].family_type, 10) || 0)) {
			var removeTagIds = familyTagIds(tag.family_id, tag.tag_id)
			if (removeTagIds.length) {
				DB.run('DELETE FROM tag_attach WHERE user_id = ? AND tag_id IN (' + removeTagIds.map(function() { return '?' }).join(', ') + ') AND ' + field + ' IN (' + remainingIndex.map(function() { return '?' }).join(', ') + ')', [
					parseInt(userId, 10) || 0
				].concat(removeTagIds, remainingIndex))
				tagIds = tagIds.concat(removeTagIds)
			}
		}
	}

	touchAttachmentCounts(tagIds, familyIds)

	return persist({ index: remainingIndex })
}
